/**
 * 운영자 메인 목록의 행 — GET /wechat-open/accounts (SPEC v0.2.0 §6.1) 가 유일한 출처다.
 * 서버가 stage/nextAction 을 판정하므로 화면은 계산하지 않는다.
 */
import { wechatOpenApi } from '@/apis/wechatOpen';
import { normalizeAccountRow } from './stageModel';

/** @returns {Promise<{rows: object[]}>} */
export async function loadAccountRows() {
    const res = await wechatOpenApi.listAccounts();
    const items = (res.data && res.data.items) || [];
    return { rows: items.map(normalizeAccountRow) };
}
